import {Avatar, ConfigProvider, List} from "antd";
import {deleteBooking} from "../api/booking";
import React from "react";
import {AppStore, setBookings, setLoading} from "../useAppPullState"; // Import css
import {confirmAlert} from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import {deleteInAdvanceBooking} from "./actions/syncUserBookings";
// import {firestore} from "../connection";

const getDateFromBooking = (bookingId) => {
    return firestore.collection("bookings").doc(bookingId).get().then((doc) => {
        if (doc.exists) {
            // console.log("Document data:", doc.data());
            return doc.data().date;
        } else {
            // doc.data() will be undefined in this case
            // console.log("No such document!");
            return '20/09/2023';
        }
    });
}

const Icon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        fill='red'
        className='bi bi-dash-square'
        viewBox='0 0 16 16'
    >
        <path
            d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z'/>
        <path d='M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z'/>
    </svg>
)


const renderItem = (user, onDelete) => (item, index) => {
    // console.log('[[BookingHistory]] item', {item});
    //06/08/2023 to date,
    // const date = item?.date || await getDateFromBooking(item.id);
    const date = item?.date;
    if(!date) {
        console.error(`No date found in`, {item});
        throw new Error(`No date found in ${JSON.stringify(item)}`);
    }
    const dateString = date.split("/").reverse().join("-");
    const lastMinuteToday = new Date()
    lastMinuteToday.setHours(23, 59, 59, 999);
    const time = new Date(dateString).getTime();
    const time1 = lastMinuteToday.getTime();
    const isTodayOrPast = (time - time1) < 0;


    const imgName = item?.data?.course?.data.imgName;
    const imagePath = `/mini-logo.jpeg`;
    return (
        <List.Item key={index}>
            <List.Item.Meta
                avatar={<Avatar src={`${imagePath}`}/>}
                title={
                    <a style={{fontStyle: "bold"}}>
                        {user?.firstName} <span
                        style={{paddingLeft: 5}}>{user?.LastName}</span>
                    </a>
                }
                description={
                    <React.Fragment>
                        <div style={{fontStyle: "bold", display: "inline-flex"}}>
                            {item?.courseName} <span
                            style={{paddingLeft: 5}}>{item?.date}</span>
                        </div>
                        {!isTodayOrPast ? <span
                            style={{float: "right", cursor: "pointer"}}
                            onClick={async () => {
                                await onDelete(item.id);
                            }}
                        >
                        <Icon/>
                      </span> : null}
                    </React.Fragment>
                }
            />
        </List.Item>
    )
}


export default () => {
    const {
        bookings,
        userInAdvanceBookings,
        user
    } = AppStore.useState(s => ({
        userInAdvanceBookings: s.userInAdvanceBookings,
        bookings: s.bookings,
        user: s.user
    }));

    const onDelete = async id => {
        await confirmAlert({
            title: "Vahvista poisto",
            message: "Oletko varma.",
            buttons: [
                {
                    label: "Kyllä",
                    onClick: async () => {
                        setLoading(true)
                        await deleteBooking({id});
                        deleteInAdvanceBooking(id);
                        setBookings(bookings.filter(item => item.id !== id));
                        setLoading(false)
                    },
                },
                {
                    label: "Ei",
                    onClick: () => console.log("Click No"),
                },
            ],
        });
    };
    // console.log('[[BookingHistory]] userInAdvanceBookings', {userInAdvanceBookings});
    return (
        <>
            {!!userInAdvanceBookings ? (
                <ConfigProvider renderEmpty={() => "Ei käytettyjä pelioikeuksia"}>
                    <List
                        itemLayout='horizontal'
                        dataSource={userInAdvanceBookings || []}
                        renderItem={renderItem(user, onDelete)}
                    />
                </ConfigProvider>
            ) : null}
        </>
    );
};
